export default __webpack_public_path__ + "static/Card26-3611ff9562b4177ef035a01eb1236c4e.png";